import {Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {BASE_URL} from './models';

@Injectable({
  providedIn: 'root',
})
export class RtPlatformService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Optional() @Inject(BASE_URL) private serverBaseUrl: any,
  ) {}
  //get url of server
  get baseUrl(): string {
    // if (isPlatformBrowser(this.platformId)) {
    //   return '';
    // }
    // settings BASE URL should have higher priority because we may run build on a local machine
    // todo: use injected settings
    // if (this.settings.BASE_URL) {
    //   return this.settings.BASE_URL;
    // }
    return 'http://localhost:4200';
    if (this.serverBaseUrl) {
      return this.serverBaseUrl;
    }
    return '';
  }

  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  get isServer(): boolean {
    return isPlatformServer(this.platformId);
  }
}
